import { HTMLAttributes, ReactElement } from "react";
import styled from "styled-components";

export interface TripleDotLoadingProps extends HTMLAttributes<HTMLSpanElement> {
  color?: string;
}

export default function TripleDotLoading({ color, ...spanProps }: TripleDotLoadingProps): ReactElement {
  return (
    <TripleDotLoadingBox {...spanProps}>
      <Dot index={0} color={color} />
      {" "}
      <Dot index={1} color={color} />
      {" "}
      <Dot index={2} color={color} />
    </TripleDotLoadingBox>
  );
}

const TripleDotLoadingBox = styled.span`
  white-space: nowrap;
`;

const Dot = styled.span<{ index: number; color?: string }>`
  display: inline-block;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background-color: ${p => p.color ?? p.theme.colorPrimary};

  @keyframes Dot-blink {
    0% {
      opacity: 0;
    }
    33% {
      opacity: 1;
    }
    67% {
      opacity: 0;
    }
    100% {
      opacity: 0;
    }
  }

  animation: Dot-blink 1s infinite;
  animation-delay: ${p => p.index * 0.125}s;
  animation-fill-mode: both;
`;
